import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as GroupsActions } from 'store/ducks/groups';

import { Validate } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Configs/Groups/components';

class Create extends Component {
  state = {
    form: {
      title: '',
      alias: '',
      description: '',
      group_roles_attributes: [],
      extra_data: {
        lock_ldap_store_place: false,
        lock_ldap_feed_local: false,
        lock_ldap_store_channel: false,
      },
    },

    errors: {},

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Configurações', to: '/configs' },
      { name: 'Grupos de Acesso', to: '/configs/groups' },
      { name: 'Novo', to: '' },
    ],
  };

  handleValidate = () => {
    const { form } = this.state;

    const rules = {
      title: {
        required: true,
      },

      description: {
        required: true,
      },

      alias: {
        required: true,
      },
    };

    const validate = Validate(form, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (!this.handleValidate()) return;

    const { form } = this.state;

    const group = {
      ...form,
      group_roles_attributes: form.group_roles_attributes.map(role => ({ auth_role_id: role.value })),
    };

    this.props.createGroupRequest({ group });
  };

  render() {
    const { form, errors, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={form}
          errors={errors}
          saving={create.loading}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
      </Page>
    );
  }
}

const mapState = state => ({
  create: state.groups.create,
});

const mapActions = dispatch => bindActionCreators(GroupsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Create);
